export default "__VITE_ASSET__JuXAHVjt__"